import { render, staticRenderFns } from "./resend-invoice-button.vue?vue&type=template&id=5595297c"
import script from "./resend-invoice-button.vue?vue&type=script&lang=js"
export * from "./resend-invoice-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports